/**
 * @fileoverview Firm Contacts directory page
 *
 * URL: /dashboard/firm-contacts
 *
 * Org-scoped curated CRM directory for banks, regulators, frequently used
 * professionals, and the org's own users. Visible to every org member;
 * editing is gated to owners and admins.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { useActiveOrg } from "@/utils/org-context";
import { FirmContactsView } from "@/components/firm-contacts/FirmContactsView";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/firm-contacts/",
)({
  component: FirmContactsPage,
  beforeLoad: () => ({
    title: "Firm Contacts",
    headerTitle: "Firm Contacts",
    headerDescription:
      "Manage firm-level contacts applicable across various jobs and users in your organisation.",
  }),
});

function FirmContactsPage() {
  const { activeOrg, isLoading } = useActiveOrg();

  if (isLoading) {
    return (
      <div className="flex h-32 items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!activeOrg) {
    throw redirect({ to: "/dashboard" });
  }

  const canEdit = activeOrg.role === "owner" || activeOrg.role === "admin";

  // Any org member may add a firm contact; editing / archiving stays admin-only.
  return (
    <FirmContactsView orgId={activeOrg._id} canEdit={canEdit} canAdd={true} />
  );
}
